import React from 'react';
import { useLayout } from '../components/results/layout/LayoutStore';
import { useSearchData } from '../data/SearchData';
import { useLocationUrl } from '../state/LocationUrl';
import { trackPageView } from './trackResults';

export function usePageTracking() {
    const { layout } = useLayout();
    const { searchData } = useSearchData();

    // Read the location URL from a ref to avoid triggering a double render when
    // searchData updates and the URL changes.
    const { locationUrlRef } = useLocationUrl();

    React.useEffect(() => {
        if (searchData) {
            const { metadata } = searchData;

            metadata.tracking &&
                trackPageView(
                    metadata.tracking,
                    layout,
                    locationUrlRef.current.href,
                );
        }
    }, [layout, locationUrlRef, searchData]);
}
